<template>
  <b-button
    class="app-button text-nowrap"
    :class="classObject"
    v-bind="{...$props, ...$attrs}"
    ref="button"
    @click="onClick"
  >
    <div class="d-flex justify-content-center align-items-center" v-if="loading">
      <b-spinner
        style="width: 1em; height: 1em;"
        :class="{'mar-r-1': !iconOnly}"
      />
      <template v-if="!iconOnly">
        <slot />
      </template>
    </div>
    <slot v-else />
  </b-button>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    iconOnly: {
      type: Boolean,
      default: false
    },
    asInput: {
      type: Boolean,
      default: false
    },
    link: {
      type: Boolean,
      default: false
    },
    linkPrimary: {
      type: Boolean,
      default: false
    },
    linkDanger: {
      type: Boolean,
      default: false
    },
    linkSecondary: {
      type: Boolean,
      default: false
    },
    linkRegular: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    regularFont: {
      type: Boolean,
      default: false
    },
    shadowed: {
      type: Boolean,
      default: false
    },
    noHoverEffect: {
      type: Boolean
    }
  },
  computed: {
    classObject () {
      return {
        'icon-only': this.iconOnly,
        'as-input': this.asInput,
        link: this.link,
        'link-primary': this.linkPrimary,
        'link-danger': this.linkDanger,
        'link-secondary': this.linkSecondary,
        'link-regular': this.linkRegular,
        'light-text': this.regularFont,
        shadowed: this.shadowed,
        'no-hover-effect': this.noHoverEffect
      }
    }
  },
  methods: {
    onClick ($event) {
      if (this.loading) return
      // Remove focused state after clicking button (UI requirement)
      this.$refs.button.blur()
      this.$emit('click', $event)
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/buttons.scss';
</style>
